// libraries
import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { AnimatePresence, motion } from "framer-motion";

// styles
import styles from "./styles.module.scss";

// components
import {
  PreferenceModal,
  Navbar,
  Section,
  Footer,
  Sidebar,
} from "src/components";
import {
  PopularBar,
  Feedback,
  ByCategory,
  BecomeEventmooner,
  AvailableOn,
  FeedbackModal,
  HorizontalBar,
  PlaneWidget,
  Events,
  NextCategories,
  CarouselNew,
} from "../old-components";

import LocationPrompt from "./LocationPrompt";
import MobFiler from "../old-components/Filters/MobFilter/MobFilter";
import DesktopFilter from "../old-components/Filters/DesktopFilter/DesktopFilter";

// api
// import { getCategories, getEventByCategory } from "../api";
import {
  getEventByCategoryCache,
  getCategoriesCache,
  clearCache,
  clearCacheCategory,
} from "../utils/cacheApi";

// context
import UserContext from "src/context/User";

// utils
import mockup from "src/utils/data";
import { getUserCurrentLocation } from "src/utils/requests";

// custom hooks
import useDidMountEffect from "src/custom_hooks/useDidMountEffect";

const Content = () => {
  const {
    user,
    userLocation,
    isCurrentLocation,
    updateUserLocation,
    staleCategory,
    setStaleCategory,
  } = useContext(UserContext);

  // states
  const [feedback, setFeedback] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const [eventData, setEventData] = useState(null);
  const [initialRender, setInitialRender] = useState(false);
  const [isFeed, setIsFeed] = useState(false);

  const [showPrompt, setShowPrompt] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showPrefModal, setShowPrefModal] = useState(false);

  const [currCategory, setCurrCategory] = useState({
    Categoryid: -1,
    CategoryName: "Today",
    Discription: "",
  });
  const [categories, setCategories] = useState([]);

  useDidMountEffect(() => {
    if (user || userLocation) onCategoryChange(currCategory);
    if (isCurrentLocation) setShowPrompt(false);
  }, [user, userLocation, initialRender]);

  useEffect(() => {
    setInitialRender(true);
    // handlePermission();

    getCategoriesCache(0)
      .then((res) => {
        if (res.data.Status) {
          setCategories([...mockup.init_categories, ...res.data.Results]);
        } else {
          toast.error(res.data.ErrorMessage);
        }
      })
      .catch((err) => {
        toast.error(err);
      });

    if (staleCategory) {
      setCurrCategory(staleCategory);
    }
  }, []);

  // toggle feedback
  const toggleFeedback = () => {
    setFeedback((prev) => setFeedback(!prev));
  };

  const onCategoryChange = (_catg) => {
    setCurrCategory(_catg);
    setStaleCategory(_catg);

    if (_catg.Categoryid === -3) {
      setIsFeed(true);
      animateScroll();
      return;
    } else {
      if (isFeed) setIsFeed(false);
    }

    setEventData(mockup.empty_3);
    animateScroll();

    let params = {
      catgId: _catg.Categoryid,
      lat: userLocation?.lat,
      lng: userLocation?.lng,
      // lat: "40.303707",
      // lng: "-72.92622",
    };

    if (user) {
      params = {
        ...params,
        userId: user.userId,
        accessToken: user.accessToken,
        lat: user?.location?.lat,
        lng: user?.location?.lng,
      };
    }

    getEventByCategoryCache(params)
      .then((res) => {
        if (res.data.Status) {
          setEventData(res.data.Results);
        } else {
          const id = `/Event${params.catgId}`;
          clearCacheCategory(id);
          setEventData(null);
        }
      })
      .catch((err) => {
        console.log(err);
        setEventData(null);
      });
  };

  const animateScroll = () => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  };

  const getCurrentLocation = () => {
    let options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    let success = (pos) => {
      setShowPrompt(false);
      setIsLoading(true);

      let lat = pos.coords.latitude;
      let lng = pos.coords.longitude;

      // ,"41.3083,-72.9279"
      getUserCurrentLocation(`${lat},${lng}`)
        .then((res) => {
          setIsLoading(false);
          if (res.status === 200) {
            clearCache();
            updateUserLocation(
              lat,
              lng,
              res.data.items[0].address?.city ||
                user?.location?.city ||
                userLocation.city,
              true
            );
          } else {
            toast.error(res.statusText);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err);
        });
    };

    let error = (err) => {
      setIsLoading(false);
      let msg = "";
      switch (err.code) {
        case err.PERMISSION_DENIED:
          msg = "User denied Geolocation";
          // msg =
          //   "Location service is disable, \n Enable location service and try again";

          setShowPrefModal(true);

          break;
        case err.POSITION_UNAVAILABLE:
          msg = "Location information is unavailable.";
          setShowPrefModal(true);
          break;
        case err.TIMEOUT:
          msg = "The request to get user location timed out.";
          break;
        case err.UNKNOWN_ERROR:
          msg = "An unknown error occurred.";
          break;
        default:
          msg = "nothing happend";
      }

      // toast.error(msg);
      console.log(err.message, err, msg);
    };

    navigator.geolocation.getCurrentPosition(success, error, options);
  };

  // const handlePermission = () => {
  //   if (navigator.permissions && navigator.permissions.query) {
  //     navigator.permissions.query({ name: "geolocation" }).then((result) => {
  //       result.onchange = function () {
  //         if (result.state === "granted") {
  //           if (userLocation?.isDefault === undefined) {
  //             setShowPrompt(false);
  //             setIsLoading(true);
  //           }
  //         }
  //       };
  //     });
  //   }
  // };

  console.log(categories);

  return (
    <div className={styles.content}>
      <div className={styles.head}>
        <Navbar />
        <Sidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
        <PopularBar
          setShowSidebar={setShowSidebar}
          handleClick={getCurrentLocation}
          showPrompt={showPrompt}
          isUpdating={isLoading}
        />
      </div>
      <HorizontalBar
        setShowForm={setShowForm}
        data={categories}
        onChange={onCategoryChange}
        active={currCategory}
      />

      {showPrompt && (
        <LocationPrompt
          user={user}
          userLocation={userLocation}
          handleClick={getCurrentLocation}
          handleRequest={() => alert("in progress")}
          className={styles.info}
        />
      )}
      <AnimatePresence>
        {isLoading && (
          <motion.div
            initial={{ height: 0, opacity: 0, padding: 0 }}
            animate={{ height: "100%", opacity: 1, padding: "0.5rem 1rem" }}
            exit={{ height: 0, opacity: 0, padding: 0 }}
            transition={{ type: "spring", stiffness: 100 }}
            className={styles.placeholder}
          >
            Updating location....
          </motion.div>
        )}
      </AnimatePresence>
      <MobFiler showForm={showForm} setShowForm={setShowForm} />
      {!isFeed ? (
        <Section>
          <Events
            heading={currCategory.CategoryName}
            items={eventData}
            user={user}
            userLocation={userLocation}
            category={currCategory}
            isTopSpace
          />
        </Section>
      ) : (
        <div>
          <DesktopFilter />
        </div>
      )}
      <Section>
        <NextCategories
          currCategory={currCategory}
          handleClick={onCategoryChange}
          user={user}
          categories={categories}
          userLocation={userLocation}
        />
      </Section>
      <ByCategory handleClick={onCategoryChange} currCategory={currCategory} />
      <BecomeEventmooner />
      <AvailableOn />
      {/* <Carousel /> */}
      <CarouselNew />
      <Feedback toggleFeedback={toggleFeedback} />
      <Footer />
      {feedback && <FeedbackModal toggleFeedback={toggleFeedback} />}
      <PlaneWidget setShowForm={setShowForm} />
      <PreferenceModal isOpen={showPrefModal} setIsOpen={setShowPrefModal} />
    </div>
  );
};

export default Content;
